<section>
  <div class="container">
    <div class="text-center mb-2">
      <h2 class="font-4xl font-bold ">Confronta i nostri servizi</h2>
    </div>

    <div class="table-responsive">
      <div class="pricing-table rounded-7 overflow-hidden border" style="min-width: 700px; max-width: 1000px; margin: 0 auto;">
        <!-- Header Row -->
        <div class="table-header d-grid  fw-bold text-center" style="grid-template-columns: 2fr 1fr 1fr 1fr 1fr;">
          <div class="header-cell service-header p-3 text-start ps-4 fs-5" style="border-right: 2px solid rgba(255, 255, 255, 0.2); letter-spacing: 1px;">SERVIZI</div>
          <div class="header-cell plan-header p-3 fs-6" style="border-right: 2px solid rgba(255, 255, 255, 0.2);">FREE</div>
          <div class="header-cell plan-header p-3 fs-6" style="border-right: 2px solid rgba(255, 255, 255, 0.2);">SILVER</div>
          <div class="header-cell plan-header p-3 fs-6" style="border-right: 2px solid rgba(255, 255, 255, 0.2);">GOLD</div>
          <div class="header-cell plan-header p-3 fs-6">PLATINO</div>
        </div>

        <!-- Feature Rows -->
        <div class="table-body">
          <div class="d-grid border-bottom transition-all" 
               *ngFor="let feature of features; let i = index" 
               style="grid-template-columns: 2fr 1fr 1fr 1fr 1fr;">
            <div class="feature-cell service-name p-3 ps-4 fw-semibold text-dark">{{ feature.name }}</div>
            <div class="feature-cell p-3 text-center">
              <span class="icon d-inline-flex align-items-center justify-content-center rounded-circle" 
                    [class.text-success]="feature.free" 
                    [class.bg-success-subtle]="feature.free"
                    [class.text-danger]="!feature.free"
                    [class.bg-danger-subtle]="!feature.free"
                    style="width: 32px; height: 32px;">
                <i [class.fa-check]="feature.free" [class.fa-times]="!feature.free" class="fas"></i>
              </span>
            </div>
            <div class="feature-cell p-3 text-center">
              <span class="icon d-inline-flex align-items-center justify-content-center rounded-circle" 
                    [class.text-success]="feature.silver" 
                    [class.bg-success-subtle]="feature.silver"
                    [class.text-danger]="!feature.silver"
                    [class.bg-danger-subtle]="!feature.silver"
                    style="width: 32px; height: 32px;">
                <i [class.fa-check]="feature.silver" [class.fa-times]="!feature.silver" class="fas"></i>
              </span>
            </div>
            <div class="feature-cell p-3 text-center">
              <span class="icon d-inline-flex align-items-center justify-content-center rounded-circle" 
                    [class.text-success]="feature.gold" 
                    [class.bg-success-subtle]="feature.gold"
                    [class.text-danger]="!feature.gold"
                    [class.bg-danger-subtle]="!feature.gold"
                    style="width: 32px; height: 32px;">
                <i [class.fa-check]="feature.gold" [class.fa-times]="!feature.gold" class="fas"></i>
              </span>
            </div>
            <div class="feature-cell p-3 text-center">
              <span class="icon d-inline-flex align-items-center justify-content-center rounded-circle" 
                    [class.text-success]="feature.platino" 
                    [class.bg-success-subtle]="feature.platino"
                    [class.text-danger]="!feature.platino"
                    [class.bg-danger-subtle]="!feature.platino"
                    style="width: 32px; height: 32px;">
                <i [class.fa-check]="feature.platino" [class.fa-times]="!feature.platino" class="fas"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

